module.exports = __webpack_public_path__ + "img/renew-leftmenu-basic-user-pic.c589658b.png";